<template>
  <vue-ckeditor
    :config="config"
    @fileUploadResponse="onFileUploadResponse($event)"
    v-model="formData.content" />
</template>

<script>
import API from '@/api'
import VueCkeditor from 'vue-ckeditor2'

export default {
  name: 'RichEditor',

  props: {
    content: {
      type: String,
      required: true
    }
  },

  components: {
    VueCkeditor
  },

  data () {
    return {
      formData: {
        content: '',
        attachs: []
      },
      config: {
        filebrowserImageUploadUrl: API.files.uploadUrl(),
        fileTools_requestHeaders: { Authorization: 'Bearer ' + this.$auth.token() },
        bodyClass: 'content',
        height: 650,
        // Ao enviar/colar uma imagem, o CKEditor grava as dimensoes naturais
        // dela num style inline (ex.: "width:1600px"), que sobrepoe o
        // `img { max-width: 100% }` do contents.css e estoura o layout do
        // artigo. Descartar width/height da imagem mantem a folha de estilos
        // no controle e a imagem responsiva.
        disallowedContent: 'img{width,height}[width,height]'
      }
    }
  },

  mounted () {
    this.formData.content = this.content
  },

  watch: {
    'formData.content' () {
      this.$emit('change', this.formData)
    }
  },

  methods: {
    onFileUploadResponse (event) {
      let response = event.data.fileLoader.xhr

      if (response.status >= 200 && response.status < 300) {
        let data = JSON.parse(response.responseText.split('|'))

        this.formData.attachs.push({
          id: data.id,
          name: data.fileName
        })

        this.deselectImage(event.editor)
      }
    },

    // Ao concluir o upload, o CKEditor troca o placeholder pela imagem final e
    // deixa o widget selecionado, o que a pinta de azul ate o usuario clicar
    // fora. Movemos o cursor para depois da imagem para que ela apareca ja
    // deselecionada. O timeout espera o editor terminar de inserir o elemento.
    deselectImage (editor) {
      if (!editor) return

      setTimeout(() => {
        try {
          const selection = editor.getSelection()
          if (!selection) return

          const element = selection.getStartElement()
          if (!element) return

          const image = element.is('img') ? element : element.findOne('img')
          const range = editor.createRange()

          // 4 === CKEDITOR.POSITION_AFTER_END. Usamos o literal para nao
          // depender do global CKEDITOR, que nao esta declarado no eslint.
          range.moveToPosition(image || element, 4)
          range.select()
        } catch (e) {
          // Se a estrutura do editor mudar, deixar a selecao como esta e
          // preferivel a interromper o fluxo de upload.
        }
      }, 100)
    }
  }
}
</script>
